export default "__VITE_ASSET__AMylFxZK__"